import React from "react";
import { Loader2 } from "lucide-react";

function Row({ item, active, onClick }) {
  const name = item.name || item.company_name;
  const meta = item.type || item.plan || item.trade || "-";
  const isActive = active?.id === item.id;
  return (
    <tr
      onClick={() => onClick(item)}
      className={`cursor-pointer border-t border-gray-100 hover:bg-br-paper ${isActive ? "bg-br-paper" : ""}`}
    >
      <td className="px-4 py-2 font-semibold">{name}</td>
      <td className="px-4 py-2 text-gray-600 text-xs uppercase tracking-widest">{meta}</td>
      <td className="px-4 py-2">
        <span className="text-[10px] uppercase tracking-widest px-2 py-0.5 rounded bg-br-paper-2">{item.status || "new"}</span>
      </td>
      <td className="px-4 py-2 text-xs text-gray-500">{new Date(item.created_at).toLocaleString()}</td>
    </tr>
  );
}

export default function AdminRecordsList({ items, loading, active, onSelect }) {
  if (loading) {
    return (
      <div className="p-10 flex items-center justify-center text-gray-500">
        <Loader2 className="animate-spin mr-2" /> Loading...
      </div>
    );
  }
  if (!items || items.length === 0) {
    return <div className="p-10 text-center text-gray-500 text-sm">No records yet.</div>;
  }
  return (
    <table className="w-full text-sm">
      <thead className="bg-br-paper-2">
        <tr className="text-left">
          <th className="px-4 py-2">Name / Company</th>
          <th className="px-4 py-2">Type</th>
          <th className="px-4 py-2">Status</th>
          <th className="px-4 py-2">Created</th>
        </tr>
      </thead>
      <tbody>
        {items.map((it) => <Row key={it.id} item={it} active={active} onClick={onSelect} />)}
      </tbody>
    </table>
  );
}
